import React, { useEffect, useState } from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "../../features/auth/authSlice";
import FormattedInput from "../common/FormattedInput";
import {
  fetchCategoryData,
  fetchLanguageData,
  fetchGenreData,
  influencerFollowerList,
} from "../../features/commonSlice/commonSlice";
import { clientInfluencerRequest } from "../../features/clientInfluencerRequestSlice/clientInfluencerRequestSlice";

const budgetData = [
  { label: "0-5", value: "0-5" },
  { label: "10-20", value: "6-10" },
  { label: "20-30", value: "11-15" },
  { label: "30-40", value: "16-20" },
  { label: "40-50", value: "21-50" },
  { label: "50+", value: "50+" },
  { label: "100+", value: "100+" }
];
const videoTypeData = [
  { label: "Dedicated", value: 1 },
  { label: "Integrated", value: 2 },
  { label: "Conceptual", value: 3 }
];

const follower_subscribers = [
  { label: "0-5k", value: "0-5k" },
  { label: "5k-10k", value: "5k-10k" },
  { label: "10k-30k", value: "10k-30k" },
  { label: "30k-50k", value: "30k-50k" },
  { label: "50k-100k", value: "50k-100k" },
  { label: "100k-200k", value: "100k-200k" },
  { label: "200k-300k", value: "200k-300k" },
  { label: "300k-500k", value: "300k-500k" },
  { label: "500k-1M", value: "500k-1M" },
  { label: "1M-2M", value: "1M-2M" },
  { label: "2M-5M", value: "2M-5M" },
  { label: "5M-10M", value: "5M-10M" },
  { label: "10M-20M", value: "10M-20M" },
  { label: "20M-30M", value: "20M-30M" },
  { label: "30M-50M", value: "30M-50M" },
  { label: "50M-100M", value: "50M-100M" },
  { label: "100M-200M", value: "100M-200M" },
  { label: "200M-300M", value: "200M-300M" },
  { label: "300M-400M", value: "300M-400M" },
  { label: "400M-500M", value: "400M-500M" },
  { label: "500M+", value: "500M+" }
];

const EnquireInfluencersRequest = (props) => {
  const { showModal, setShowModal, decodedToken } = props;
  const dispatch = useDispatch();
  const [langList, setLangList] = useState([]);
  const [errors, setErrors] = useState("");
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [genreList, setGenreList] = useState([]);
  const [followrsData, setFollowersData] = useState([])

  const { inflfollowsData, languageData,
    genreData, status: commonStatus } = useSelector(
      (state) => state.influencer
    );
  const [formData, setFormData] = useState({
    product: "",
    no_of_influencer: "",
    budget: "",
    product_details: "",
    detailed_desc: "",
    channel_data: {
      youTube_status: "",
      youTube: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
        video_type: []
      },
      facebook_status: "",
      facebook: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      },
      instagram_status: "",
      instagram: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      },
      twitter_X_status: "",
      twitter_X: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      },
      linkedIn_status: "",
      linkedIn: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      },
      whatsapp_status: "",
      whatsapp: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      },
      telegram_status: "",
      telegram: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      },
      threads_status: "",
      threads: {
        language: [],
        min_budget: "",
        max_budget: "",
        genre: [],
        follower_subscriber: [],
      }
    }
  });

  const mapErrors = (errorData) => {
    const errorMap = {};
    errorData.forEach((error) => {
      if (!errorMap[error.param]) {
        const path = error.param.split(".").join("_");
        errorMap[path] = error.msg;
      }
    });
    return errorMap;
  };
  useEffect(() => {
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

  useEffect(() => {
    dispatch(fetchLanguageData());
    dispatch(fetchGenreData());
    dispatch(influencerFollowerList())
  }, [dispatch]);

  useEffect(() => {
    if (languageData) {
      setLangList(languageData);
    }
  }, [languageData]);

  useEffect(() => {
    if (genreData) {
      setGenreList(genreData);
    }
  }, [genreData]);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      console.log("Follower API data:", inflfollowsData);
      setFollowersData(inflfollowsData?.data || []);
    }
  }, [inflfollowsData]);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      channel_data: {
        ...prevState.channel_data,
        [name]: checked
      }
    }));
  };

  const handleSelectChange = (name, selectedOption) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      let field = newFormData;
      const keys = name.split(".");
      keys.slice(0, -1).forEach((key) => {
        if (!field[key]) {
          field[key] = {};
        }
        field = field[key];
      });
      field[keys[keys.length - 1]] = selectedOption;
      return newFormData;
    });
  };

  const handleSelectChange1 = (name, selectedOption) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      let field = newFormData;
      const keys = name.split(".");
      keys.slice(0, -1).forEach((key) => {
        if (!field[key]) {
          field[key] = {};
        }
        field = field[key];
      });
      field[keys[keys.length - 1]] = selectedOption;
      return newFormData;
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      let field = newFormData;
      const keys = name.split(".");
      keys.slice(0, -1).forEach((key) => {
        if (!field[key]) {
          field[key] = {};
        }
        field = field[key];
      });
      field[keys[keys.length - 1]] = value;
      return newFormData;
    });
  };

  useEffect(() => {
    console.log("sjhfsjkhfkjsdh szhdfsdjkhf ==>", followrsData);

  }, [followrsData])


  const closeModal = () => {
    setShowModal(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const influencerData = {
        client_id: decodedToken?.UsrId,
        product: formData.product,
        no_of_influencer: formData.no_of_influencer?.label,
        budget: formData.budget,
        product_details: formData?.product_details,
        detailed_desc: formData?.detailed_desc,
        channel_data: {
          youTube_status: formData.channel_data.youTube_status ? "1" : "0",
          youTube: formData.channel_data.youTube,
          facebook_status: formData.channel_data.facebook_status ? "1" : "0",
          facebook: formData.channel_data.facebook,
          instagram_status: formData.channel_data.instagram_status ? "1" : "0",
          instagram: formData.channel_data.instagram,
          twitter_X_status: formData.channel_data.twitter_X_status ? "1" : "0",
          twitter_X: formData.channel_data.twitter_X,
          linkedIn_status: formData.channel_data.linkedIn_status ? "1" : "0",
          linkedIn: formData.channel_data.linkedIn,
          whatsapp_status: formData.channel_data.whatsapp_status ? "1" : "0",
          whatsapp: formData.channel_data.whatsapp,
          telegram_status: formData.channel_data.telegram_status ? "1" : "0",
          telegram: formData.channel_data.telegram,
          threads_status: formData.channel_data.threads_status ? "1" : "0",
          threads: formData.channel_data.threads
        }
      };

      dispatch(clientInfluencerRequest(influencerData))
        .unwrap()
        .then((result) => {
          if (result.status) {
            toast.success(result.message, {
              onClose: () => {

                setFormData({
                  product: "",
                  no_of_influencer: "",
                  budget: "",
                  channel_data: {
                    youTube_status: "",
                    youTube: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: "",
                      video_type: []
                    },
                    facebook_status: "",
                    facebook: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    },
                    instagram_status: "",
                    instagram: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    },
                    twitter_X_status: "",
                    twitter_X: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    },
                    linkedIn_status: "",
                    linkedIn: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    },
                    whatsapp_status: "",
                    whatsapp: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    },
                    telegram_status: "",
                    telegram: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    },
                    threads_status: "",
                    threads: {
                      language: [],
                      min_budget: "",
                      max_budget: "",
                      genre: "",
                      follower_subscriber: ""
                    }
                  }
                })

              }
            });
            closeModal();
          } else {
            setLoginError(result.message);
            setErrorData(result.form_err);
            toast.error(result.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored"
            });
          }
        })
        .catch((err) => {
          setLoginError(err.message);
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        show={showModal}
        onHide={closeModal}
        aria-labelledby="ModalHeader"
        size="xl"
        backdrop="static" // Prevents closing on backdrop click
        keyboard={false} // Prevents closing on ESC key press
      >
        <Modal.Header closeButton>
          <Modal.Title>Enquiry Influencers Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="p-0">
                    <div>
                      <>
                        <div className="row">
                          <div>
                            <h5 className="text-primary">Personal Details</h5>
                          </div>

                          <div className="col-md-3">
                            <div className="mb-3">
                              <label htmlFor="username" className="form-label">
                                Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="influencer_name"
                                readOnly={true}
                                disabled={true}
                                placeholder="Please Enter Name"
                                value={decodedToken?.UsrName}
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="mb-3">
                              <label
                                htmlFor="concernname"
                                className="form-label"
                              >
                                Company name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="concern_name"
                                readOnly={true}
                                disabled={true}
                                placeholder="Please Enter Name"
                                value={decodedToken?.UsrCompName}
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-lg-3 mb-3">
                            <div>
                              <label htmlFor="product" className="form-label">
                                Product <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="product"
                                placeholder="Enter product name"
                                value={formData.product}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.product && <p>{errors.product}</p>}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 mb-3">
                            <div className="mb-3">
                              <label
                                htmlFor="no_of_influencer"
                                className="form-label"
                              >
                                No of influencers required{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                name="no_of_influencer"
                                options={budgetData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "no_of_influencer",
                                    selected
                                  )
                                }
                                value={formData.no_of_influencer}
                              />
                              <div className="text-danger">
                                {errors.no_of_influencer && (
                                  <p>{errors.no_of_influencer}</p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label htmlFor="concernname" className="form-label">
                                Product Details{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="product_details"
                                placeholder="Please Enter Product Details"
                                value={formData?.product_details || ""}
                                onChange={handleInputChange}
                                rows={3}
                              />
                              <div className="text-danger">
                                {errors.product_details && (
                                  <p>{errors.product_details}</p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label htmlFor="concernname" className="form-label">
                                Product Description{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="detailed_desc"
                                placeholder="Please Enter product description"
                                value={formData?.detailed_desc || ""}
                                onChange={handleInputChange}
                                rows={3}
                              />
                              <div className="text-danger">
                                {errors.detailed_desc && (
                                  <p>{errors.detailed_desc}</p>
                                )}
                              </div>
                            </div>
                          </div>

                        </div>
                      </>
                      <hr />

                      <div className="row mt-2 g-3">
                        <h5 className="text-primary">Channel details</h5>

                        <label>
                          Select Below Channels
                          {errors.channel_data && (
                            <p className="text-danger small error">
                              {errors.channel_data}
                            </p>
                          )}
                        </label>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="youTube_status"
                            checked={formData.channel_data.youTube_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="youtubeCheckbox"
                          >
                            {" "}
                            YouTube
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="facebook_status"
                            checked={formData.channel_data.facebook_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="facebookCheckbox"
                          >
                            {" "}
                            Facebook
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="instagram_status"
                            checked={formData.channel_data.instagram_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="instagramCheckbox"
                          >
                            {" "}
                            Instagram
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="twitter_X_status"
                            checked={formData.channel_data.twitter_X_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="twitterCheckbox"
                          >
                            {" "}
                            Twitter (X)
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="linkedIn_status"
                            checked={formData.channel_data.linkedIn_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="linkedinCheckbox"
                          >
                            {" "}
                            LinkedIn
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="whatsapp_status"
                            checked={formData.channel_data.whatsapp_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="whatsappCheckbox"
                          >
                            {" "}
                            Whatsapp
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="telegram_status"
                            checked={formData.channel_data.telegram_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="telegramCheckbox"
                          >
                            {" "}
                            Telegram
                          </label>
                        </div>
                        <div className="form-check col-lg-3 mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="threads_status"
                            checked={formData.channel_data.threads_status}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="threadsCheckbox"
                          >
                            {" "}
                            Threads
                          </label>
                        </div>
                      </div>
                      {formData.channel_data.youTube_status && (
                        <div id="youtubeInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">You Tube</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="youtubeUrl">
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.youTube.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.youTube.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.youTube.language",
                                    selected
                                  )
                                }
                              />

                              <div className="text-danger">
                                {errors.channel_data_youTube_language && (
                                  <p>
                                    {errors.channel_data_youTube_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.youTube.min_budget"
                                placeholder="Enter youTube minimum budget"
                                value={formData.channel_data.youTube.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_youTube_min_budget && (
                                  <p>
                                    {errors.channel_data_youTube_min_budget}
                                  </p>
                                )}
                              </div>
                              <div className="video_cost_disp p-1 text-white"> </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.youTube.max_budget"
                                placeholder="Enter youTube maximum budget"
                                value={formData.channel_data.youTube.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_youTube_max_budget && (
                                  <p>
                                    {errors.channel_data_youTube_max_budget}
                                  </p>
                                )}
                              </div>
                              <div className="video_cost_disp p-1 text-white"> </div>
                            </div>

                            {/* 
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  name="channel_data.youTube.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange1(
                                      "channel_data.youTube.genre",
                                      selected
                                    )
                                  }
                                  value={formData?.channel_data?.youTube.genre}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_youTube_genre && (
                                    <p>{errors.channel_data_youTube_genre}</p>
                                  )}
                                </div>

                              </div>
                            </div> */}

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.youTube.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.youTube.genre", selected)
                                  }
                                  value={formData?.channel_data?.youTube?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_youTube_genre && (
                                    <p>{errors.channel_data_youTube_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.youTube.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.youTube.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.youTube
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_youTube_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_youTube_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="subscribers">
                                Video type
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.youTube.video_type"
                                options={videoTypeData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.youTube.video_type",
                                    selected
                                  )
                                }
                                value={formData.channel_data.youTube.video_type}
                              />
                              <div className="text-danger">
                                {errors.channel_data_youTube_video_type && (
                                  <p>
                                    {errors.channel_data_youTube_video_type}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {formData.channel_data.facebook_status && (
                        <div id="facebookInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">Facebook</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.facebook.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.facebook.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.facebook.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_facebook_language && (
                                  <p>
                                    {errors.channel_data_facebook_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.facebook.min_budget"
                                placeholder="Enter budget"
                                value={formData.channel_data.facebook.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_facebook_min_budget && (
                                  <p>
                                    {errors.channel_data_facebook_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.facebook.max_budget"
                                placeholder="Enter budget"
                                value={formData.channel_data.facebook.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_facebook_max_budget && (
                                  <p>
                                    {errors.channel_data_facebook_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.facebook.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange1(
                                      "channel_data.facebook.genre",
                                      selected
                                    )
                                  }
                                  value={formData?.channel_data?.facebook.genre}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_facebook_genre && (
                                    <p>{errors.channel_data_facebook_genre}</p>
                                  )}
                                </div>

                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.facebook.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.facebook.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.facebook
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_facebook_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_facebook_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {formData.channel_data.instagram_status && (
                        <div id="facebookInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">Instagram</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.instagram.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.instagram.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.instagram.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_instagram_language && (
                                  <p>
                                    {errors.channel_data_instagram_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.instagram.min_budget"
                                placeholder="Enter instagram minimum budget"
                                value={formData.channel_data.instagram.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_instagram_min_budget && (
                                  <p>
                                    {errors.channel_data_instagram_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label htmlFor="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.instagram.max_budget"
                                placeholder="Enter instagram maximum budget"
                                value={formData.channel_data.instagram.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_instagram_max_budget && (
                                  <p>
                                    {errors.channel_data_instagram_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.instagram.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.instagram.genre", selected)
                                  }
                                  value={formData?.channel_data?.instagram?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_instagram_genre && (
                                    <p>{errors.channel_data_instagram_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4 mb-3">
                              <label for="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.instagram.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.instagram.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.instagram
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_instagram_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_instagram_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {formData.channel_data.twitter_X_status && (
                        <div id="twitter">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">Twitter </h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.twitter_X.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.twitter_X.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.twitter_X.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_twitter_X_language && (
                                  <p>
                                    {errors.channel_data_twitter_X_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.twitter_X.min_budget"
                                placeholder="Enter twitter_X minimum budget"
                                value={formData.channel_data.twitter_X.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_twitter_X_min_budget && (
                                  <p>
                                    {errors.channel_data_twitter_X_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.twitter_X.max_budget"
                                placeholder="Enter twitter_X maximum budget"
                                value={formData.channel_data.twitter_X.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_twitter_X_max_budget && (
                                  <p>
                                    {errors.channel_data_twitter_X_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.twitter_X.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.twitter_X.genre", selected)
                                  }
                                  value={formData?.channel_data?.twitter_X?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_twitter_X_genre && (
                                    <p>{errors.channel_data_twitter_X_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.twitter_X.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.twitter_X.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.twitter_X
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_twitter_X_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_twitter_X_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {formData.channel_data.linkedIn_status && (
                        <div id="facebookInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">LinkedIn</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.linkedIn.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.linkedIn.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.linkedIn.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_linkedIn_language && (
                                  <p>
                                    {errors.channel_data_linkedIn_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.linkedIn.min_budget"
                                placeholder="Enter linkedIn minimum budget"
                                value={formData.channel_data.linkedIn.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_linkedIn_min_budget && (
                                  <p>
                                    {errors.channel_data_linkedIn_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.linkedIn.max_budget"
                                placeholder="Enter linkedIn maximum budget"
                                value={formData.channel_data.linkedIn.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_linkedIn_max_budget && (
                                  <p>
                                    {errors.channel_data_linkedIn_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.linkedIn.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.linkedIn.genre", selected)
                                  }
                                  value={formData?.channel_data?.linkedIn?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_linkedIn_genre && (
                                    <p>{errors.channel_data_linkedIn_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>


                            <div className="col-md-4 mb-3">
                              <label for="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.linkedIn.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.linkedIn.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.linkedIn
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_linkedIn_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_linkedIn_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {formData.channel_data.whatsapp_status && (
                        <div id="facebookInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">Whatsapp</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.whatsapp.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.whatsapp.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.whatsapp.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_whatsapp_language && (
                                  <p>
                                    {errors.channel_data_whatsapp_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.whatsapp.min_budget"
                                placeholder="Enter whatsapp minimum budget"
                                value={formData.channel_data.whatsapp.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_whatsapp_min_budget && (
                                  <p>
                                    {errors.channel_data_whatsapp_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.whatsapp.max_budget"
                                placeholder="Enter whatsapp maximum budget"
                                value={formData.channel_data.whatsapp.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_whatsapp_max_budget && (
                                  <p>
                                    {errors.channel_data_whatsapp_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.whatsapp.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.whatsapp.genre", selected)
                                  }
                                  value={formData?.channel_data?.whatsapp?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_whatsapp_genre && (
                                    <p>{errors.channel_data_whatsapp_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.whatsapp.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.whatsapp.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.whatsapp
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_whatsapp_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_whatsapp_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {formData.channel_data.telegram_status && (
                        <div id="facebookInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">Telegram</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.telegram.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.telegram.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.telegram.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_telegram_language && (
                                  <p>
                                    {errors.channel_data_telegram_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.telegram.min_budget"
                                placeholder="Enter telegram maximum budget"
                                value={formData.channel_data.telegram.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_telegram_min_budget && (
                                  <p>
                                    {errors.channel_data_telegram_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.telegram.max_budget"
                                placeholder="Enter telegram maximum budget"
                                value={formData.channel_data.telegram.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_telegram_max_budget && (
                                  <p>
                                    {errors.channel_data_telegram_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.telegram.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.telegram.genre", selected)
                                  }
                                  value={formData?.channel_data?.telegram?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_telegram_genre && (
                                    <p>{errors.channel_data_telegram_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.telegram.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.telegram.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.telegram
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_telegram_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_telegram_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {formData.channel_data.threads_status && (
                        <div id="facebookInfo">
                          <div className="row">
                            <div className="mt-2">
                              <h5 className="text-primary">Threads</h5>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label>
                                Select language
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti={true}
                                name="channel_data.threads.language"
                                options={langList?.data}
                                classNamePrefix="select"
                                value={formData.channel_data.threads.language}
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.threads.language",
                                    selected
                                  )
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_threads_language && (
                                  <p>
                                    {errors.channel_data_threads_language}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Minimum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.threads.min_budget"
                                placeholder="Enter threads minimum budget"
                                value={formData.channel_data.threads.min_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_threads_min_budget && (
                                  <p>
                                    {errors.channel_data_threads_min_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="ygenere">
                                Maximum budget
                                <span className="text-danger">*</span>:
                              </label>
                              <FormattedInput
                                type="text"
                                className="form-control"
                                name="channel_data.threads.max_budget"
                                placeholder="Enter threads maximum budget"
                                value={formData.channel_data.threads.max_budget}
                                onChange={handleInputChange}
                                required
                              />
                              <div className="text-danger">
                                {errors.channel_data_threads_max_budget && (
                                  <p>
                                    {errors.channel_data_threads_max_budget}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label htmlFor="fbgenere">
                                  Genre<span className="text-danger">*</span>:
                                </label>
                                <Select
                                  isMulti
                                  name="channel_data.threads.genre"
                                  options={genreList?.data?.map((genre) => ({
                                    value: genre?.value,
                                    label: genre?.label
                                  }))}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    handleSelectChange("channel_data.threads.genre", selected)
                                  }
                                  value={formData?.channel_data?.threads?.genre || ""}
                                />
                                <div className="text-danger">
                                  {errors.channel_data_threads_genre && (
                                    <p>{errors.channel_data_threads_genre}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <label for="subscribers">
                                Followers or subscriber requirement
                                <span className="text-danger">*</span>:
                              </label>
                              <Select
                                isMulti
                                name="channel_data.threads.follower_subscriber"
                                options={followrsData}
                                classNamePrefix="select"
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "channel_data.threads.follower_subscriber",
                                    selected
                                  )
                                }
                                value={
                                  formData.channel_data.threads
                                    .follower_subscriber
                                }
                              />
                              <div className="text-danger">
                                {errors.channel_data_threads_follower_subscriber && (
                                  <p>
                                    {errors.channel_data_threads_follower_subscriber}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EnquireInfluencersRequest;
